import { TextField } from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete'
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import { MDBBtn, MDBCard, MDBCardBody, MDBCardFooter, MDBCardTitle, MDBCol, MDBContainer, MDBRow } from 'mdbreact'
import React, { useEffect, useState } from 'react'
import 'date-fns'
import moment from 'moment'
import DateFnsUtils from '@date-io/date-fns';
import axios from '../../../authAxios';
import { useHistory, useLocation } from 'react-router'


const TrackStickerVisaDetails = () => {

    const history = useHistory()
    const { state: { details_id } = { details_id: '' } } = useLocation();
    const [reviewForm, setReviewForm] = useState([])
    // const [userDetails, setUserDetails] = useState({})
    const [data, setData] = useState({})

    let userDetails = {}


    const getApplicationData = () => {
        // console.log('data', data.length)
        if(Object.keys(data).length == 0) return <div>No data found!</div>
        let createdBy = data?.contact_details?.first_name + ' ' + data?.contact_details?.last_name 
        let createdOn = getReadableDate(data?.created_on) 
        return <MDBRow  >
            <MDBCol md='4' lg='4' xl='4' sm='6'>
                <div style={{ fontWeight: 500, display: 'flex', gap: 5, marginBottom: 15 }}>
                    <div style={{ color: '#6c757db8' }}>Ref No:</div><div>{data?.application_reference_code }</div>
                </div>
            </MDBCol>
            <MDBCol md='4' lg='4' xl='4' sm='6'>
                <div style={{ fontWeight: 500, display: 'flex', gap: 5, marginBottom: 15 }}>
                    <div style={{ color: '#6c757db8' }}>Country of Residence(COR): </div><div>{data?.origin}</div>
                </div>
            </MDBCol>
            <MDBCol md='4' lg='4' xl='4' sm='6'>
                <div style={{ fontWeight: 500, display: 'flex', gap: 5, marginBottom: 15 }}>
                    <div style={{ color: '#6c757db8' }}>Travelling to:</div><div>{data?.travelling_to_country}</div>
                </div>
            </MDBCol>
            <MDBCol md='4' lg='4' xl='4' sm='6'>
                <div style={{ fontWeight: 500, display: 'flex', gap: 5, marginBottom: 15 }}>
                    <div style={{ color: '#6c757db8' }}>Visa Type:</div><div> {data?.visa_type} | {data?.visa_entry_type} Entry</div>
                </div>
            </MDBCol>
            <MDBCol md='4' lg='4' xl='4' sm='6'>
                <div style={{ fontWeight: 500, display: 'flex', gap: 5, marginBottom: 15 }}>
                    <div style={{ color: '#6c757db8' }}>Nationality:</div><div>{data?.nationality}</div>
                </div>
            </MDBCol>
            <MDBCol md='4' lg='4' xl='4' sm='6'>
                <div style={{ fontWeight: 500, display: 'flex', gap: 5, marginBottom: 15 }}>
                    <div style={{ color: '#6c757db8' }}>Visa Duration:</div><div>{data?.total_days + " " + data?.duration_type}</div>
                </div>
            </MDBCol>
            <MDBCol md='4' lg='4' xl='4' sm='6'>
                <div style={{ fontWeight: 500, display: 'flex', gap: 5, marginBottom: 15 }}>
                    <div style={{ color: '#6c757db8' }}>Created by:</div><div>{createdBy}</div>
                </div>
            </MDBCol>
            <MDBCol md='4' lg='4' xl='4' sm='6'>
                <div style={{ fontWeight: 500, display: 'flex', gap: 5, marginBottom: 15 }}>
                    <div style={{ color: '#6c757db8' }}>Created on:</div><div>{createdOn}</div>
                </div>
            </MDBCol>
            <MDBCol md='4' lg='4' xl='4' sm='6'>
                <div style={{ fontWeight: 500, display: 'flex', gap: 5, marginBottom: 15 }}>
                    <div style={{ color: '#6c757db8' }}>Cateogory:</div><div style={{ textTransform: 'capitalize' }}>{data?.visa_category}</div>
                </div>
            </MDBCol>

            <MDBCol md='4' lg='4' xl='4' sm='6'>
                <div style={{ fontWeight: 500, display: 'flex', gap: 5, marginBottom: 15 }}>
                    <div style={{ color: '#6c757db8' }}>Travel Dates:</div><div>{getTravelDates()}</div>
                </div>
            </MDBCol>

        </MDBRow>
    }

    const handleInputError = (value, item, index) => {
        let errArr = [...reviewForm]
        if (item.validations.mandatory && value == '') {
            errArr[index].validations.hasErr = true
            errArr[index].validations.errMsg = "This field is required"
            setReviewForm(errArr)
        } else if (item.validations.mandatory && item.validations.min_length > value.length) {
            errArr[index].validations.hasErr = true
            errArr[index].validations.errMsg = "Min length should be greater than " + item.validations.min_length
            setReviewForm(errArr)
        }
        else {
            errArr[index].validations.hasErr = false
            errArr[index].validations.errMsg = ""
            setReviewForm(errArr)

        }
    }

    const handleClick = () => {
        history.push('/track-sticker-visa')
    }

    const handleInputChange = (name, value, index) => {
        // console.log("index", reviewForm[index])
        let data = [...reviewForm];
        data[index].value = value
        // console.log('index', data)
        setReviewForm(data);
    }

    var definePropertyDynamically = function (_object, _propertyName, _propertyValue) {
        var config = {
            value: _propertyValue || "",
            writable: true,
            enumerable: true,
            configurable: true
        };
        Object.defineProperty(_object, _propertyName, config);
    };

    const FieldRender = (card, i) => {
        // definePropertyDynamically(userDetails, card.name, new Date())

        switch (card.type) {
            case 'textField':
                return card.validations?.display && TextFieldRender(card, i)
            case 'dateControl':
                return card.validations?.display && DateFieldRender(card, i)
            case 'dropdown':
                return card.validations?.display && DropdownRender(card, i)
            default:
                console.log("Exception :", card.type)
                break;
        }
    }


    const TextFieldRender = (item, i) => {
        return <MDBCol size="12" md='6' lg="4" className="" key={i} style={{ height: '8vh', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '15px' }} >
            <div style={{ width: '100%' }}>

                <TextField
                    name={item.name}
                    style={{ width: '100%' }}
                    value={item?.value}
                    label={item.label}
                    error={item.validations.hasErr == true && item.validations.mandatory}
                    // required={item.validations.mandatory}
                    onInput={e => handleInputError(e.target.value, item, i)}
                    // disabled={item.validations.read_only}
                    disabled={true}
                    // onChange={(e) => { definePropertyDynamically(userDetails, e.target.name, e.target.value); console.log("User Details :", userDetails) }}
                    onChange={(e) => {
                        const re = /^[0-9\b]+$/;
                        if (item.validations?.isDigit) {
                            if (e.target.value === '' || re.test(e.target.value)) {
                                handleInputChange(e.target.name, e.target.value, i);
                                definePropertyDynamically(userDetails, item.name, e.target.value)
                            }
                        }
                        else {
                            handleInputChange(e.target.name, e.target.value, i);
                            definePropertyDynamically(userDetails, item.name, e.target.value)
                        }
                    }}
                />
                {item.validations.hasErr == true ? <small style={{ color: 'red' }}> {item.validations.errMsg}</small> : <small >&nbsp;</small>}
            </div>

        </MDBCol>

    }

    const DateFieldRender = (item, i) => {
        return <MDBCol size="12" md='6' lg="4" key={i} className="" style={{ height: '8vh', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '15px' }} >
            <div style={{ width: '100%' }}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                        disableFuture={item.validations.when === "before"}
                        label={item.label}
                        className="w-100"
                        variant="inline"
                        // format="YYYY-MM-DD"
                        format="dd-MM-yyyy"
                        id={item.name}
                        // required={item.validations?.mandatory}
                        onInput={e => handleInputError(e, item, i)}
                        // value={moment(`${userDetails[item.name]}`).toISOString()}
                        value={item.value}
                        disabled={true}
                        // disabled={item.validations.read_only == true}
                        style={{ width: '100%', marginTop: '2vh' }}
                        autoOk
                        InputProps={{ readOnly: true }}
                        onChange={(e, value) => {
                            let dateValue = value
                            handleInputChange(item.name, e, i);
                            definePropertyDynamically(userDetails, item.name, moment(dateValue, "DD-MM-YYYY").format('YYYY-MM-DD'))
                            // console.log(moment(dateValue, "DD-MM-YYYY").format('YYYY-MM-DD'))
                        }}
                    // onChange={(date, value) => { definePropertyDynamically(userDetails,item.name, value); console.log("User Details :", item.name , " =>", userDetails) }}
                    />
                </MuiPickersUtilsProvider>
                {item.validations.hasErr == true ? <small style={{ color: 'red' }}> {item.validations.errMsg}</small> : <small >&nbsp;</small>}
            </div>
        </MDBCol >
    }

    const DropdownRender = (item, i) => {
        return <MDBCol size="12" md='6' lg="4" key={i} className="" style={{ height: '8vh', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '15px' }} >
            <div style={{ width: '100%' }}>

                <Autocomplete
                    name={item.name}
                    value={item?.value}
                    options={item.options.map((i) => i)}
                    getOptionLabel={option => option}
                    renderInput={
                        (params) => <TextField {...params} label={item.label} />
                    }
                    style={{ width: '100%' }}
                    onInput={(e, newValue) => handleInputError(newValue, item, i)}
                    // onChange={(e, newValue) => { definePropertyDynamically(userDetails, e.target.name, newValue);; console.log("User Details :", userDetails) }}
                    onChange={(e, newValue) => {
                        handleInputChange(item.name, newValue, i);
                        definePropertyDynamically(userDetails, item.name, newValue)
                    }}
                    // disabled={item.validations.read_only === true}
                    disabled={true}
                />
                {item.validations.hasErr == true ? <small style={{ color: 'red' }}> {item.validations.errMsg}</small> : <small >&nbsp;</small>}
            </div>

        </MDBCol>
    }

    const fetchStikcerVisaDetails = async () => {
        // console.log('state => ', state)
        try {
            const res = await axios.get(`visa/getApplicationDetailsForStickerVisa?application_id=${details_id}`)
            if (res.data?.data == 'success') {
                let resData = res.data
                setData(resData?.dataobj)
                // console.log('res', res)
            } else {
                setReviewForm([])
            }

        } catch (error) {
            setReviewForm([])
        }
    }

    useEffect(() => {

        fetchStikcerVisaDetails()
    }, [])

    const getReadableDate = (givenDate) => {
        let monthNames = ["Jan", "Feb", "Mar", "Apr",
            "May", "Jun", "Jul", "Aug",
            "Sep", "Oct", "Nov", "Dec"];
        var dt = new Date(givenDate) 
        if(!dt || dt == 'Invalid Date') dt = new Date()
        var dateStr = dt.getDate() + "-" + monthNames[(dt.getMonth())] + "-" + dt.getFullYear() + " "
        if(!dateStr) return new Date()
        return dateStr
    }

    const getTravelDates = () => `${getReadableDate(data?.journey_start_date)} to ${getReadableDate(data?.journey_end_date)}`


    const getLabel = txt => {
        let str = txt.split("_").join(" ")
        return str
        // return str[0].toCapitalize() + " " + str[1].toCapitalize()
    }

    return (
        <div>
            {/* <VisaeroJumbotron jumbotrontext="Visa Details" /> */}
            <MDBContainer fluid>
                <h5 style={{ padding: '0 15px', color:'white' }}>Application Details</h5>
                <MDBCard style={{ width: '100%', padding: 15 }} className=" mt-4">
                    <MDBCardBody className="p-0">
                        {getApplicationData()}
                    </MDBCardBody>
                </MDBCard>

                <div className='mt-4'>
                    <MDBCard>
                        <MDBCardBody>
                            <MDBCardTitle>Details</MDBCardTitle>
                            <hr />
                            <MDBContainer fluid>
                                <MDBRow>
                                    {/* {reviewForm.length > 0 && reviewForm.map(FieldRender)} */}
                                    {data?.visa_form ? data?.visa_form && Object.keys(data?.visa_form).map((keys, i) => (
                                        <MDBCol size="12" md='6' lg="4" key={i} className="" style={{ height: '8vh', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '15px' }} >
                                            <div style={{ width: '100%' }}>
                                                <TextField
                                                    name={keys}
                                                    style={{ width: '100%' }}
                                                    value={data.visa_form[keys]}
                                                    label={getLabel(keys)}

                                                    inputProps={{
                                                        style: {
                                                            color: '#707070'
                                                        }
                                                    }}
                                                    InputLabelProps={{
                                                        style: { textTransform: 'capitalize', color: '#707070' }
                                                    }}
                                                    disabled={true}
                                                />
                                            </div>
                                        </MDBCol>
                                    )):<div>No data Found!</div>}
                                </MDBRow>
                            </MDBContainer>
                        </MDBCardBody>
                        <MDBCardFooter>
                            <MDBRow style={{ display: 'flex', alignItems: 'center', justifyContent: 'end' }}>
                                <MDBBtn color="none" style={{ color: 'white', backgroundColor: localStorage.getItem('brand_color'), fontSize: 'calc(8px + .5rem)', textTransform: 'none', minWidth: '150px' }} onClick={handleClick}>Ok</MDBBtn>
                            </MDBRow>
                        </MDBCardFooter>
                    </MDBCard>
                </div>
            </MDBContainer>

        </div>
    )
}

export default TrackStickerVisaDetails